module.exports = __webpack_public_path__ + "static/img/12.38a1da8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/travelpolicy/12.jpg
// module id = DAU/
// module chunks = 0